// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"19":"918cbaba","60":"1e438b26","755":"581b72aa","810":"12c42870"}[chunkId] + ".css";
};